import ProfileDropdown from "./elements/ProfileDropdown";
import ProjectQuicklink from "./elements/ProjectQuicklink";

const HeaderNav = () => {
  return (
    <>
      <style>{`
        .main-header {
          background: #fff !important;
          border-bottom: 1px solid #f0f0f0 !important;
          box-shadow: 0 1px 8px rgba(0,0,0,0.06) !important;
          padding: 0 20px !important;
          height: 56px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
        }
      `}</style>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left: sidebar toggle */}
        <ul className="navbar-nav" style={{ margin: 0, padding: 0 }}>
          <li className="nav-item" style={{ listStyle: "none" }}>
            <a
              data-widget="pushmenu"
              href="#"
              role="button"
              style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: "36px", height: "36px", borderRadius: "8px",
                color: "#9e9e9e", textDecoration: "none", fontSize: "1rem",
                transition: "background 0.15s, color 0.15s",
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "#f5f5f5"; e.currentTarget.style.color = "#424242"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#9e9e9e"; }}
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>

        {/* Right: actions */}
        <ul className="navbar-nav" style={{ margin: 0, padding: 0, display: "flex", alignItems: "center", gap: "8px" }}>
          <ProjectQuicklink />
          <ProfileDropdown />
        </ul>
      </nav>
    </>
  );
};

export default HeaderNav;
